import Text from 'components/Text';
import { Grid, Stack } from '../../node_modules/@mui/material/index';
import { style } from 'constant/constants';
import { Link } from 'react-router-dom';
import { isAreaAdmin, isSuperAdmin } from 'utils/utils';
import { useSelector } from 'react-redux';

const AccessDenied = () => {
  const { userData } = useSelector((store) => store.auth);
  const backLink =
    isAreaAdmin(userData?.roles) || isSuperAdmin(userData?.roles)
      ? '/Stores'
      : '/StoreInfo/projects';
  return (
    <>
      <Grid>
        <Stack
          style={{
            color: style.LIGHT.primary,
            marginRight: '10vh',
            marginTop: '20vh'
          }}>
          <Text variant="h4" textAlign="center">
            403 - Access Denied
          </Text>
        </Stack>
        <Text
          variant="h6"
          textAlign="center"
          style={{ marginRight: '40vh', marginLeft: '40vh', marginTop: '2vh' }}>
          The page you are trying to access is restricted. <br />
          Ensure that you have the necessary permissions or access rights. <br /> Please navigate
          <Link variant="text" to={backLink}>
            <span
              style={{
                color: style.LIGHT.primary,
                fontFamily: style.fontFamily,
                textDecoration: 'underline',
                marginLeft: '1vh',
                marginRight: '1vh'
              }}>
              back
            </span>
          </Link>
          to site.
        </Text>
      </Grid>
    </>
  );
};

export default AccessDenied;
